// extracted by mini-css-extract-plugin
export default {"text":"SnsShare_text__v0lwi","otherText":"SnsShare_otherText__-4fuL","imgs":"SnsShare_imgs__w2Ve7","img":"SnsShare_img__E0wW2"};